import isProd from './isProd';

export const LAB_ALLOWED_MEMBER_IDS_PROD: ReadonlyArray<string> = [
  // William Ritossa
  'cf01cdf4-1019-4641-bf97-843fcd8fae15',
  // Geo
  '28ede005-db57-4f99-b85c-6b635b7620c6',
  // Harry Nguyen
  'cb6bfdbf-3bad-403a-a24a-7782678402e4',
  // Muen
  '8eb032a9-bd00-431f-b28c-9165aeada95e',
  // William Feng
  'd677d037-18de-4603-9026-acd4e7f506c0',
  // Chris Lee
  '5ebc0a7f-6511-4b4f-86e0-e346c7c94750',
  // Shay
  '945dd4c1-3c4f-40d0-8314-fddd0e4e3d51',
  // Fabien
  '54948b8f-b6b3-46c6-9da1-b84294cae4a5',
  // Sam Drown
  '0386d4bc-43f1-4f1a-ada0-c667c3dbffe4',
  // Joss
  '69fbdc21-93a5-47e3-b3c6-2355d47e363b',
  // Kostya
  '30c95693-418a-45fa-b79b-f8ea5556b616',
  // Tom S
  '9c901c03-71b3-4033-af4d-dcfc59237bc2',
  // Jake G
  'a86d01ed-c9e9-4df0-8378-9d35e8e7c7a1',
  // James Nevett
  '84da38e8-2f41-4223-8ccd-c3df7b19a2cb',
  // GusPlus
  'e3c17c15-59f7-4258-bf28-4e6841dbd544',
  // Laurent Jaubert
  'f51367c0-6d7d-47b1-9aee-c136e90a9121',
];

const allowedMemberIdsProd = new Set(LAB_ALLOWED_MEMBER_IDS_PROD.map((id) => id.toLowerCase()));

export function canAccessLab(user: { id_member?: string | null } | null | undefined): boolean {
  if (!user?.id_member) {
    return false;
  }

  if (!isProd()) {
    return true;
  }

  return allowedMemberIdsProd.has(user.id_member.toLowerCase());
}
